// src/components/AuthorBio.js
import React from 'react';
import { Link } from 'react-router-dom';

const AuthorBio = ({ author }) => {
  if (!author) return null;

  return (
    <div className="mt-16 flex items-center gap-x-6 rounded-2xl bg-dark-card/40 border border-white/10 p-6">
      <Link to={`/blog/author/${author.id}`}>
        {author.avatarUrl ? (
          <img className="h-16 w-16 rounded-full" src={author.avatarUrl} alt={author.name} />
        ) : (
          <div className="h-16 w-16 rounded-full bg-dark-card flex items-center justify-center text-dark-text-primary font-bold text-2xl">
            {author.name.charAt(0)}
          </div>
        )}
      </Link>
      <div>
        <h3 className="text-lg font-semibold text-dark-text-primary">
          <Link to={`/blog/author/${author.id}`} className="hover:underline">
            {author.name}
          </Link>
        </h3>
        <p className="mt-1 text-sm text-dark-text-secondary">
          {author.description}
        </p>
      </div>
    </div>
  );
};

export default AuthorBio;